import { useCallback } from 'react';

const useNotifications = () => {
  const showNotification = useCallback((message, type = 'info', duration = 4000) => {
    if (window.modernNotifications) {
      return window.modernNotifications.show(message, type, duration);
    } else {
      // Fallback para mostrar en consola
      console.log(`[${type.toUpperCase()}] ${message}`);
      return null;
    }
  }, []);

  const showSuccess = useCallback((message, duration) => {
    return showNotification(message, 'success', duration);
  }, [showNotification]);

  const showError = useCallback((message, duration) => {
    return showNotification(message, 'error', duration);
  }, [showNotification]);

  const showWarning = useCallback((message, duration) => {
    return showNotification(message, 'warning', duration);
  }, [showNotification]);

  const showInfo = useCallback((message, duration) => {
    return showNotification(message, 'info', duration);
  }, [showNotification]);

  const showGrid = useCallback((message, duration) => {
    return showNotification(message, 'grid', duration);
  }, [showNotification]);

  const showRuler = useCallback((message, duration) => {
    return showNotification(message, 'ruler', duration);
  }, [showNotification]);

  const showGuides = useCallback((message, duration) => {
    return showNotification(message, 'guides', duration);
  }, [showNotification]);

  const clearNotifications = useCallback(() => {
    if (window.modernNotifications) {
      window.modernNotifications.clear();
    }
  }, []);

  const removeNotification = useCallback((id) => {
    if (window.modernNotifications) {
      window.modernNotifications.remove(id);
    }
  }, []);

  return {
    showNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showGrid,
    showRuler,
    showGuides,
    clearNotifications,
    removeNotification
  };
};

export default useNotifications;